module.exports = __webpack_public_path__ + "static/6-8df43f66c3b0dafc3114a603174c755f.jpg";